// Translation: Password change > Landing > Form (English)
export default Object.freeze({
	form: {
		actions: {
			changePassword: 'Password change'
		},
		fields: {
			oldPassword: {
				placeholder: 'Enter your old password'
			},
			password: {
				placeholder: 'Enter your new password'
			},
			passwordConfirmation: {
				placeholder: 'Confirm your new password'
			}
		},
		title: 'Change your password'
	}
})
